{
  "CallsheetPublic": {
    "loadingTitle": "加载通告单",
    "notPublishedTitle": "通告单未发布",
    "notPublishedSubtitle": "通告单处于草稿状态。请通知作者发布通告单。",
    "poweredByAtellio": "Powered by Atellio",
    "metaDescription": "由{{teamName}}在{{companyName}}制作的通告单",
    "builtWith": "构建于"
  },
  "PublicCallsheetView": {
    "callsheetFor": "通告单 -",
    "confirmReceived": "确认收到",
    "confirmed": "已确认"
  },
  "CallsheetPdfButton": {
    "downloadAsPDF": "下载为PDF"
  },
  "CallsheetContacts": {
    "name": "姓名",
    "fillFromResource": "从资源填充",
    "role": "角色",
    "removeContact": "删除联系人",
    "mainContacts": "主要联系人",
    "addContact": "添加联系人"
  },
  "CallsheetCallTime": {
    "toLabel": "至",
    "fromLabel": "从",
    "removeDate": "移除日期",
    "addDateRange": "添加日期范围",
    "yourCallTime": "您的通话时间",
    "generalCrewCallTime": "通用工作人员通话时间"
  },
  "CallsheetOutline": {
    "title": "大纲",
    "placeholder": "写下当天的概要"
  },
  "CallsheetSectionSchedule": {
    "schedule": "日程安排",
    "removeTime": "移除时间",
    "addTime": "添加时间",
    "title": "标题",
    "description": "描述",
    "removeLocation": "移除位置",
    "addSchedule": "添加日程"
  },
  "CallsheetSectionLocation": {
    "header": "位置",
    "removeLocation": "移除位置",
    "addLocation": "添加位置",
    "weather": "天气",
    "weatherUnavailable": "发布后将显示天气",
    "high": "高",
    "low": "低"
  },
  "CallsheetTeamMembers": {
    "addResource": "添加资源",
    "newGroup": "新组"
  },
  "CallsheetAddResources": {
    "title": "添加资源",
    "group": "组：{{name}}",
    "pick": "选入通告单",
    "onCallsheet": "已在通告单上",
    "noResults": "未找到资源",
    "add": "添加到通告单",
    "added_other": "已将 {{count}} 人添加到通告单",
    "addFailed": "未能将所有人添加到通告单，请重试。"
  },
  "CallsheetTeamItem": {
    "actions": "团队成员操作",
    "role": "角色",
    "note": "备注",
    "purchaseOrder": "订单号",
    "email": "电子邮件",
    "phone": "电话",
    "callTime": "召集时间",
    "addEmail": "添加电子邮件",
    "addPhoneNumber": "添加电话号码",
    "removePersonalCallTime": "移除个人召集时间",
    "showPersonalCallTime": "显示个人召集时间",
    "removeContactDetails": "移除联系信息",
    "showContactDetails": "显示联系信息",
    "addPersonalNote": "添加个人备注",
    "editPersonalNote": "编辑个人备注",
    "removeTeamMember": "删除团队成员"
  },
  "CallsheetTeamGroup": {
    "addSlot": "添加插槽",
    "addGroup": "添加组"
  },
  "CallsheetTeamGroupHeader": {
    "groupName": "组名",
    "removeGroup": "删除组",
    "areYouSure": "你确定吗？",
    "removeGroupWarning": "这将删除与该组关联的所有插槽",
    "delete": "删除",
    "groupNotEmpty": "该组非空",
    "groupNotEmptyDesc": "如果组中存在角色和费用，则无法删除该组。请将它们移到其他组或删除后再继续。"
  },
  "CallsheetTeamSectionHeader": {
    "areYouSure": "你确定吗？",
    "removeSectionWarning": "这将删除与该生产相关的所有插槽",
    "delete": "删除"
  },
  "CallsheetDocument": {
    "displayError": "无法显示通告单",
    "billing": "账单",
    "social": "社交",
    "hardDrive": "硬盘"
  },
  "CallsheetSectionNotes": {
    "title": "附加备注",
    "placeholder": "写下附加备注…"
  },
  "CallsheetLocationMap": {
    "directions": "路线在新窗口中打开",
    "map": "地图",
    "mapOf": "{{destination}}的地图"
  },
  "CallsheetPdf": {
    "address": "地址",
    "purchaseOrderFor": "{{displayName}}的订单号：{{purchaseOrder}}",
    "billing": "账单",
    "social": "社交",
    "hardDrive": "硬盘",
    "outline": "大纲",
    "descriptionHere": "此处描述",
    "personalNote": "致{{displayName}}的个人备注",
    "poNumber": "订单号：",
    "callTime": "召集时间",
    "for": "为",
    "from": "从",
    "to": "至",
    "mainContacts": "主要联系人",
    "mainContactsPlural": "主要联系人",
    "location": "位置",
    "schedule": "日程安排",
    "additionalNotes": "附加备注",
    "attachments": "附件",
    "fileURL": "文件网址",
    "weather": "天气",
    "high": "高",
    "low": "低",
    "note": "备注"
  },
  "TransferCallsheetDialog": {
    "title": "转移到工作区",
    "description_one": "将 {{name}} 移至其他工作区和团队。",
    "description_other": "将 {{count}} 个通告单移至其他工作区和团队。",
    "fieldWorkspace": "目标工作区",
    "fieldTeam": "目标团队",
    "success_one": "通告单已转移",
    "success_other": "已转移 {{count}} 个通告单"
  },
  "CallsheetActions": {
    "transfer": "转移到工作区"
  },
  "ChooseCallsheetTeam": {
    "title": "新建通告单",
    "description": "通告单属于团队。请选择新通告单所在的团队。"
  }
}
